import {format, parse} from "date-fns";
import {
    Pending,
    Cancelled,
    Confirmed,
    CourierOrdered,
    Delivered,
    DNPrinted,
    OnTheWayOut,
    Returned,
    Returning, Ordered, Packaging, Delivering, Out, Closed, Invalid
} from "../components/States";
import React from "react";


const formatHuman = (date) => {
    try {
        return format(date, 'yyyy-MM-dd')
    } catch (e) {
        return null
    }
}
const parseHuman = (dateString) => {
    try {
        return parse(dateString, 'yyyy-MM-dd')
    } catch (e) {
        return null
    }
}

const determineAddress = addressString => {
    try {
        // Try to parse the addressString as JSON
        // const parsedAddress = JSON.parse(addressString);

        return addressString?.address_com
    } catch (e) {
        // If parsing fails, return the addressString as it is
        return addressString;
    }
}

const generateUUID = () => {
    let dt = new Date().getTime();
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, c => {
        let r = (dt + Math.random() * 16) % 16 | 0;
        dt = Math.floor(dt / 16);
        return (c === 'x' ? r : (r & 0x3 | 0x8)).toString(16);
    });
};

const daysBetween = (date1, date2) => {
    const differenceMs = Math.abs(date2 - date1)
    // Convert milliseconds to days
    return Math.ceil(differenceMs / (1000 * 60 * 60 * 24))
}

const downloadBlob = (blob, filename = "download") => {
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
};


const orderStatusMap = {
    ordered: Ordered,
    confirmed: Confirmed,
    packaging: Packaging,
    delivering: Delivering,
    out: Out,
    returned: Returned,
    closed: Closed,
    invalid: Invalid,
}

const mergeDataIfNotNull = (objects) => {
    if (objects.some(obj => obj === null)) return null
    return objects.reduce((acc, obj) => {
        return { ...acc, ...obj };
    }, {});
}


const extractSlugFromUrl = (url) => {
    if (!url) return null;

    try {
        const parsedUrl = new URL(url);
        const parts = parsedUrl.pathname.split('/');
        const index = parts.indexOf('waybill');
        if (index !== -1 && parts.length > index + 1) {
            return parts[index + 1];
        }
        throw new Error();
    } catch {
        throw new Error('Nem jó QR kód!');
    }
};
const combineLoading = loadingStates => loadingStates.some(Boolean)

const daysFromNow = (x) => {
    const date = new Date();
    date.setDate(date.getDate() + x);
    return date;
}

export {formatHuman, parseHuman, determineAddress, generateUUID, daysBetween, downloadBlob, combineLoading, mergeDataIfNotNull, orderStatusMap, extractSlugFromUrl, daysFromNow}